import LessonEdit from './lessonEdit'
export default LessonEdit
